const CustomerDisplay = (props) => {
  const { clubSignup, customer } = props;
  if (customer) {
    return (
      <>
        {renderCustomerName(customer)}
        {customer.emails[0].email}
      </>
    );
  }
  return clubSignup.email;
};
export default CustomerDisplay;

const renderCustomerName = (customer) => {
  if (!customer.firstName || !customer.lastName) {
    return null;
  }
  return (
    <>
      {customer.firstName} {customer.lastName} <br />
    </>
  );
};
